export const MenuItems = [
    {
        title: 'Home',
        url: '/',
        cName: 'nav-link'
    }
    ,
    {
        title: 'About',
        url: '/about',
        cName: 'nav-link'
    },
    {
        title: 'Mission',
        url: '/mission',
        cName: 'nav-link'
    },
    {
        title: 'Events',
        url: '/events',
        cName: 'nav-link'
    },
    {
        title: 'Blog',
        url: '/blog',
        cName: 'nav-link'
    },
    {
        title: 'Learn',
        url: '/',
        cName: 'nav-link'
    },
    // {
    //     title: 'Sign-up',
    //     url: '#',
    //     cName: 'nav-link-mobile'
    // },
];